import React, { useState, useEffect } from 'react';

const CarouselSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Sample images from online sources - Online Tuition Theme
  const slides = [
    {
      id: 1,
      image: 'https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg?auto=compress&cs=tinysrgb&w=1600',
      title: 'Interactive Online Learning',
      description: 'Engage with expert tutors through live video sessions'
    },
    {
      id: 2,
      image: 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1600',
      title: 'Personalized Tutoring',
      description: 'One-on-one attention tailored to your learning needs'
    },
    {
      id: 3,
      image: 'https://images.pexels.com/photos/4144923/pexels-photo-4144923.jpeg?auto=compress&cs=tinysrgb&w=1600',
      title: 'Global Learning Community',
      description: 'Connect with tutors and students from around the world'
    },
    {
      id: 4,
      image: 'https://images.pexels.com/photos/1181391/pexels-photo-1181391.jpeg?auto=compress&cs=tinysrgb&w=1600',
      title: 'Flexible Study Schedule',
      description: 'Learn at your own pace, anytime, anywhere'
    },
    {
      id: 5,
      image: 'https://images.pexels.com/photos/4145153/pexels-photo-4145153.jpeg?auto=compress&cs=tinysrgb&w=1600',
      title: 'Advanced Learning Tools',
      description: 'Access cutting-edge educational technology and resources'
    }
  ];

  // Auto-slide effect - auto-advance every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // Next slide
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  // Previous slide
  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  // Go to specific slide
  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="w-full">
      {/* Main carousel */}
      <div className="relative w-full h-96 md:h-[500px] overflow-hidden bg-black">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-800 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-8">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">{slide.title}</h2>
              <p className="text-lg md:text-xl text-gray-100">{slide.description}</p>
            </div>
          </div>
        ))}

        {/* Navigation buttons */}
        <button
          onClick={prevSlide}
          className="btn btn-circle btn-lg btn-ghost absolute left-5 top-1/2 -translate-y-1/2 z-20 text-white hover:bg-white/20"
        >
          ❮
        </button>
        <button
          onClick={nextSlide}
          className="btn btn-circle btn-lg btn-ghost absolute right-5 top-1/2 -translate-y-1/2 z-20 text-white hover:bg-white/20"
        >
          ❯
        </button>
      </div>

      {/* Indicators/Dots */}
      <div className="flex justify-center gap-3 py-6 bg-base-100">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`btn ${
              index === currentSlide
                ? 'btn-active btn-primary'
                : 'btn-ghost'
            } h-3 w-3 rounded-full p-0`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CarouselSlider;
